var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"clima"},[_c('Clima')],1)]),_c('div',{staticClass:"dolar"},[_c('Dolar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }